import { selectAtom } from "jotai/utils";
import { shallowEqual } from "../../../utils/shallowEqual";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";

/**
 * Atom that selects current section state from the questionnaire.
 *
 * This includes:
 * - currentSectionIndex: The index of the current section
 * - lastViewedSectionIndex: The index of the last viewed section
 * - currentSection: The current section object
 * - isFirstSection: Whether we're on the first section
 * - isLastSection: Whether we're on the last section
 * - totalSections: The total number of sections
 *
 * Uses shallow equality to prevent unnecessary re-renders when the selector
 * returns a new object but the property values haven't changed.
 */
export const questionnaireCurrentSectionAtom = selectAtom(
  questionnaireReducerAtom,
  state => {
    const currentSection = state.sections[state.currentSectionIndex];
    const isFirstSection = state.currentSectionIndex === 0;
    const isLastSection =
      state.currentSectionIndex === state.sections.length - 1;

    return {
      currentSectionIndex: state.currentSectionIndex,
      lastViewedSectionIndex: state.lastViewedSectionIndex,
      currentSection,
      isFirstSection,
      isLastSection,
      totalSections: state.sections.length,
    };
  },
  shallowEqual,
);
